import Distribucio from "./Distribucio";

class Proveidor {
    constructor(
        public id= 0,
        public key= 0,
        public nom= "",
        public responsable= '',
        public recordatori= 0,
        public telefon= "",
        public email= "",
        public reparteix= 0,
        public comanda= 0,
        public emailing= true,
        public document= "",
        public estat = 0,
        public distribucions: Array<Distribucio> = [],
    ) {
        this.id = id;
        this.key = key;
        this.nom = nom;
        this.responsable = responsable;
        this.recordatori = recordatori;
        this.estat = estat;
        this.telefon = telefon;
        this.email = email;
        this.reparteix = reparteix;
        this.comanda = comanda;
        this.emailing = emailing;
        this.document = document;
        this.estat = estat;
        this.distribucions = distribucions;
    }
}
export default Proveidor;